export const regiones = [
  {
    id: 1,
    nombre: "Altiplano",
    descripcion: "La meseta más alta del mundo, caracterizada por su clima frío y seco, paisajes desérticos y lagos salados. Hogar de culturas ancestrales y sitios arqueológicos importantes.",
    clima: "Frío y seco",
    altitud: "3,600 - 4,100 msnm",
    coordenadas: [-16.5, -68.15],
    imagen: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800",
    lugares: [1, 2, 3, 12, 13, 17, 19, 21, 22, 23, 24],
    caracteristicas: ["Cultura ancestral", "Paisajes únicos", "Sitios arqueológicos", "Lagos salados"],
    mejorEpoca: "Abril a Octubre",
    destacado: true
  },
  {
    id: 2,
    nombre: "Valles",
    descripcion: "Región templada con clima mediterráneo, fértiles valles interandinos y ciudades históricas coloniales. Ideal para el turismo cultural y gastronómico.",
    clima: "Templado",
    altitud: "1,800 - 2,800 msnm",
    coordenadas: [-18.5, -65.5],
    imagen: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800",
    lugares: [4, 5, 8, 10, 18, 20, 26],
    caracteristicas: ["Gastronomía", "Arquitectura colonial", "Vinos", "Clima templado"],
    mejorEpoca: "Todo el año",
    destacado: true
  },
  {
    id: 3,
    nombre: "Yungas",
    descripcion: "Zona de transición entre los Andes y la Amazonía, con clima tropical húmedo, vegetación exuberante y paisajes montañosos espectaculares.",
    clima: "Tropical húmedo",
    altitud: "1,200 - 2,400 msnm",
    coordenadas: [-16.5, -67.5],
    imagen: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
    lugares: [14, 25],
    caracteristicas: ["Vegetación exuberante", "Aventura", "Cascadas", "Biodiversidad"],
    mejorEpoca: "Mayo a Octubre",
    destacado: false
  },
  {
    id: 4,
    nombre: "Llanos",
    descripcion: "Extensas planicies orientales con clima semi-tropical, sabanas, bosques secos y misiones jesuíticas coloniales de gran valor histórico.",
    clima: "Semi-tropical",
    altitud: "200 - 800 msnm",
    coordenadas: [-17.8, -63.2],
    imagen: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800",
    lugares: [6, 11, 15, 27, 28],
    caracteristicas: ["Misiones jesuíticas", "Sabana", "Historia colonial", "Gastronomía oriental"],
    mejorEpoca: "Mayo a Octubre",
    destacado: true
  },
  {
    id: 5,
    nombre: "Amazonía",
    descripcion: "Selva tropical húmeda con alta biodiversidad, ríos navegables y ecosistemas únicos. Ideal para el ecoturismo y la observación de fauna silvestre.",
    clima: "Tropical húmedo",
    altitud: "150 - 500 msnm",
    coordenadas: [-14.5, -67.5],
    imagen: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800",
    lugares: [7, 9, 16, 29, 30],
    caracteristicas: ["Biodiversidad", "Ecoturismo", "Ríos", "Fauna silvestre"],
    mejorEpoca: "Mayo a Septiembre",
    destacado: true
  }
]

